import Model from 'src/storage/base';

class AdminAppointmentDetailModel extends Model {
  id = 'AdminAppointmentDetailModel';
  apiConfig = {
    appointmentDetail: {
      url: '/admin/appointment/detail',
      validation: {
        id: 'string'
      },
      cancellable: true
    },
    patientDetail: {
      url: 'patient/detail',
      validation: {
        id: 'userId'
      },
      cancellable: true
    },
    hospitals: {
      url: 'hospital/list',
      validation: {
        limit: 'number'
      },
      cancellable: true
    },
    updateStatus: {
      url: 'appointment/update/status',
      validation: {
        id: 'string',
        value: 'string'
      },
      cancellable: true
    },
    doctor_detail: {
      url: 'doctor/detail',
      validation: {
        id: 'number'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile'
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };
  loadDetail = (id, cb) => {
    this.setState({ appointment: null });
    this.api('appointmentDetail', { id }, (error, appointment) => {
      this.setState({ appointment });
      cb && cb(appointment);
    });
  };

  updateStatus = (appointment, status, cb) => {
    const req = {
      id: appointment.id,
      value: status
    };
    this.api('updateStatus', req, (err, res, success) => {
      cb && cb(err, res, success);
      if (!success) {
        appointment.data.status = status;
        this.setState({ appointment });
      }
    });
  };
}

const model = new AdminAppointmentDetailModel();
export default model;
